// MODULES
import React from "react";

// COMPONENTS
import EditableField from "@routes/Cob/components/EditableField/EditableField";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";
import NumberField from "@routes/Cob/components/NumberField/NumberField";
import QuestionField from "@routes/Cob/components/QuestionField/QuestionField";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, validFields, numberLocaleFormatter, onFieldChange, onFieldBlur, onOptionsListChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>Erfarenhetsbakgrund</h3>

				<div className={"experienceTable"}>
					<div className={"header"}>
						<div className={"headerType"}>
							Placering
						</div>
						<div className={"headerField"}>
							Antal affärer under senaste 3 åren
						</div>
						<div className={"headerExp"}>
							Kunskap och erfarenhet
						</div>
					</div>
					<FieldsCollection
						style={{
							width: "100% !important"
						}}
						fields={[
							{
								render: (
									<FieldsCollection
										className={"tableRow"}
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Aktier</h4>
														<QuestionField
															style={{
																height: "40px"
															}}
															Component={NumberFieldWithName}
															name="kyc_experience_aktier_investments"
															value={fields.kyc_experience_aktier_investments || ""}
															unit={fields.kyc_experience_aktier_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_aktier_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_aktier"
														options={fields.radio_kyc_knowledge_aktier.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Fonder</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_fonder_investments"
															value={fields.kyc_experience_fonder_investments || ""}
															unit={fields.kyc_experience_fonder_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_fonder_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_fonder"
														options={fields.radio_kyc_knowledge_fonder.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Obligationer</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_obligationer_investments"
															value={fields.kyc_experience_obligationer_investments || ""}
															unit={fields.kyc_experience_obligationer_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_obligationer_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_obligationer"
														options={fields.radio_kyc_knowledge_obligationer.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Aktieindexobligationer</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_aio_investments"
															value={fields.kyc_experience_aio_investments || ""}
															unit={fields.kyc_experience_aio_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_aio_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_aio"
														options={fields.radio_kyc_knowledge_aio.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Sprinter</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_sprinter_investments"
															value={fields.kyc_experience_sprinter_investments || ""}
															unit={fields.kyc_experience_sprinter_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_sprinter_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_sprinter"
														options={fields.radio_kyc_knowledge_sprinter.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Kreditcertifikat</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_kreditcertifikat_investments"
															value={fields.kyc_experience_kreditcertifikat_investments || ""}
															unit={fields.kyc_experience_kreditcertifikat_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_kreditcertifikat_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_kreditcertifikat"
														options={fields.radio_kyc_knowledge_kreditcertifikat.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>AutoCalls</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_autocalls_investments"
															value={fields.kyc_experience_autocalls_investments || ""}
															unit={fields.kyc_experience_autocalls_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_autocalls_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_autocalls"
														options={fields.radio_kyc_knowledge_autocalls.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							}, {
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Derivat</h4>
														<QuestionField
															Component={NumberFieldWithName}
															name="kyc_experience_derivat_investments"
															value={fields.kyc_experience_derivat_investments || ""}
															unit={fields.kyc_experience_derivat_investments ? " st" : undefined}
															decimals={0}
															valid={validFields.kyc_experience_derivat_investments}
															customInputFormatter={numberLocaleFormatter}
															onChange={onFieldChange}
															onBlur={onFieldBlur}
														/>
													</React.Fragment>
												),
											}, {
												render: (
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_kyc_knowledge_derivat"
														options={fields.radio_kyc_knowledge_derivat.options}
														onChange={onOptionsListChange}
													/>
												),
											},
										]}
									/>
								),
							},
						]}
					/>
				</div>
			</div>
		);
	}
}


// PRIVATE COMPONENTS
function NumberFieldWithName(props) {
	return <EditableField {...props} Component={NumberField}/>;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/nordfk-cob/Fields/collections/CollectionExperience.js